import { PageSubtitle } from "@/shared/ui/page-subtitle"
import { EmployeesStatistics } from "./employees-statistics"
import { SocialProgramStatistics } from "./social-program-statistics"
import { CommunityStats } from "./community-stats"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { fetchCommunityStatistics, fetchCommunityTransactionAggregates, fetchLatestTransactions, fetchLatestUsers, fetchRegistrationStatistics, selectCommunityStatisticsFirstLoad, selectCommunityTransactionStatisticsFirstLoad, selectLatestTransactionsFirstLoad, selectLatestUsersFirstLoad, selectRegistrationStatisticsFirstLoad } from "../model"
import { SumBonusTransactions } from "./sum-bonus-transactions"
import { CountBonusTransactions } from "./count-bonus-transactions"
import { RegistrationStatistics } from "./registration-statistics"
import { LatestUsersList } from "./latest-users-list"
import { LatestTransactionsList } from "./latest-transactions-list"

export const CommunityStatistics = () => {
    const isCommunityStatisticsFirstLoad = useAppSelector(selectCommunityStatisticsFirstLoad)
    const isCommunityTransactionsStatisticsFirstLoad = useAppSelector(selectCommunityTransactionStatisticsFirstLoad)
    const isRegistrationStatisticsFirstLoad = useAppSelector(selectRegistrationStatisticsFirstLoad)
    const isLatestUsersFirstLoad = useAppSelector(selectLatestUsersFirstLoad)
    const isLatestTransactionsFirstLoad = useAppSelector(selectLatestTransactionsFirstLoad)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (isCommunityStatisticsFirstLoad) {
            dispatch(fetchCommunityStatistics())
        }
        if (isCommunityTransactionsStatisticsFirstLoad) {
            dispatch(fetchCommunityTransactionAggregates())
        }
        if (isRegistrationStatisticsFirstLoad) {
            dispatch(fetchRegistrationStatistics())
        }
        if (isLatestUsersFirstLoad) {
            dispatch(fetchLatestUsers())
        }
        if (isLatestTransactionsFirstLoad) {
            dispatch(fetchLatestTransactions())
        }
    }, [])
    
    return (
        <div className='flexbox'>
            <div className='flexbox'>
                <PageSubtitle title='Статистика cообщества' />
                <div className='grid grid-cols-12 gap-4 auto-rows-fr'>
                    <div className='col-span-12 xxl:col-span-4'>
                        <CommunityStats />
                    </div>
                    <div className='col-span-6 xxl:col-span-4'>
                        <EmployeesStatistics />
                    </div>
                    <div className='col-span-6 xxl:col-span-4'>
                        <SocialProgramStatistics />
                    </div>
                </div>
            </div>
            <div className='flexbox'>
                <PageSubtitle title='Пользователи'>
                    <div className='grid grid-cols-10 gap-4 auto-rows-fr'>
                        <div className='col-span-10 xl:col-span-5 xxl:col-span-3'>
                            <LatestTransactionsList />
                        </div>
                        <div className='col-span-10 xl:col-span-5 xxl:col-span-3'>
                            <LatestUsersList />
                        </div>
                        <div className='col-span-10 xl:col-span-10 xxl:col-span-4'>
                            <RegistrationStatistics />
                        </div>
                    </div>
                </PageSubtitle>
            </div>
            <div className='flexbox'>
                <PageSubtitle title='Бонусы'>
                    <div className='grid grid-cols-12 gap-4 auto-rows-fr'>
                        <div className='col-span-6'>
                            <SumBonusTransactions />
                        </div>
                        <div className='col-span-6'>
                            <CountBonusTransactions />
                        </div>
                    </div>
                </PageSubtitle>
            </div>
        </div>
    )
}